import { FaPlus, FaMinus } from 'react-icons/fa';

export default function Accordion({
  children,
  className,
  label,
  open,
  handleClick,
  disabled = false,
}) {
  return (
    <div
      className={`w-full transition-flex-grow duration-500 ${
        open ? 'flex flex-col flex-grow' : 'flex-grow-0 flex-shrink'
      } ${className ? className : ''}`}
    >
      <div
        onClick={() => !disabled && handleClick()}
        className={`flex flex-row justify-between items-center px-3 py-2 border-b border-black ${
          disabled 
            ? 'cursor-not-allowed opacity-50' 
            : 'hover:bg-gray-100 cursor-pointer'
        }`}
      >
        <div className={`text-lg font-bold ${disabled ? 'text-gray-400' : ''}`}>
          {label}
          {disabled && <span className="text-xs ml-2 font-normal">(Not available)</span>}
        </div>
        <div className={`text-lg ${disabled ? 'text-gray-400' : ''}`}>
          {open ? <FaMinus /> : <FaPlus />}
        </div>
      </div>
      <div
        className={`p-3 flex flex-row h-full w-full overflow-auto ${
          open ? 'visible' : 'hidden'
        }`}
      >
        {children}
      </div>
    </div>
  );
}
